import SectionHeaderWithIcon from "@/components/company/shared/section-header-with-icon";
import ToggleableBadgeList from "@/components/company/shared/toggleable-badge-list";
import { useTranslation } from "@/hooks/useTranslation";
import { CompanyDTO } from "@shaarp/common";
import { CpuIcon } from "lucide-react";

const TECHNOLOGIES_LIMIT = 12;

type CompanyTechnologiesSectionProps = {
  readonly company: CompanyDTO;
  readonly className?: string;
};

/**
 * The company's technologies and its ad and analytics pixels, as the desktop
 * card shows them (`CardCompanyTechnologies`), for the mobile page and the
 * preview panel.
 */
export default function CompanyTechnologiesSection({
  company,
  className,
}: CompanyTechnologiesSectionProps) {
  const { t } = useTranslation();
  const technologies = company.technologies ?? [];
  const adPixels = company.adPixels ?? [];

  if (technologies.length === 0 && adPixels.length === 0) return null;

  return (
    <section className={className}>
      <SectionHeaderWithIcon
        icon={CpuIcon}
        title={t("company.insights.digital.technologiesTitle")}
      />
      <div className="flex flex-col gap-3">
        {technologies.length > 0 && (
          <ToggleableBadgeList
            items={technologies}
            initialDisplay={TECHNOLOGIES_LIMIT}
            getKey={(tech) => tech}
          />
        )}
        {adPixels.length > 0 && (
          <div className="flex flex-col gap-2">
            <span className="text-sm text-muted-foreground">
              {t("company.insights.digital.adPixelsTitle")}
            </span>
            <ToggleableBadgeList
              items={adPixels}
              initialDisplay={TECHNOLOGIES_LIMIT}
              getKey={(pixel) => pixel}
            />
          </div>
        )}
      </div>
    </section>
  );
}
